export const GOOGLE_LOGIN_ERROR_QUERY_PARAM = 'gl_error';

export const POLL_USER_DATA_INTERVAL = 900000;
export const SETUP_PERSONA_REQUIRED = 'setup_persona_required';
export const POST_LOGIN_REDIRECT_URL = 'next_url';
